/* eslint-disable import/prefer-default-export */
import { globalDataApi } from '../globalDataApi';

const destinationsEndpoints = globalDataApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getDestinations: query({
      query: params => ({
        keepUnusedDataFor: 0,
        params: { pageNumber: params.page + 1, ...params },
        url: `get-destinations`,
      }),
    }),
  }),
});

export const { useGetDestinationsQuery } = destinationsEndpoints;
